import { WALL_API, ENDPOINTS } from 'constants/index'
import handleSocketEvent from 'redux/actions/conversations/handleSocketAct'

import SocketConnection from './SocketConnection'

const { dashboardService } = ENDPOINTS
const { SOCKET: wallAPIOptions } = WALL_API

const SocketDash = new SocketConnection(dashboardService, handleSocketEvent)
const SocketWall = new SocketConnection(wallAPIOptions, handleSocketEvent)

export { SocketDash, SocketWall }

export default {
  startAll() {
    SocketDash.start()
    SocketWall.start()
  },
  destroyAll() {
    SocketDash.destroy()
    SocketWall.destroy()
  }
}
